// src/components/ViewCart.js
import React from "react";
import { Box, Link } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

const ViewCart = () => {
  const pageUrl = "https://www.alphabetsigns.com/cart-contents.html";

  return (
    <Box>
      <Link href={pageUrl} underline="none">
        <ShoppingCartIcon sx={{ color: "#c82027" }} /> View Cart
      </Link>
    </Box>
  );
};

export default ViewCart;
